const crossApp = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async queryInnerMessageList({ rootState }, params = {}) {
      const data = await rootState.http("/message/aggregate/inner/queryInnerMessageList", params);
      return data;
    },
    async findUnreadQuantity({ rootState }, params = {}) {
      const data = await rootState.http("/message/aggregate/inner/findUnreadQuantity", params);
      return data;
    },
    async readMessage({ rootState }, params = {}) {
      const data = await rootState.http("/message/aggregate/inner/readMessage", params);
      return data;
    },
    async readMessageBySystem({ rootState }, params = {}) {
      const data = await rootState.http("/message/aggregate/inner/readMessageBySystem", params);
      return data;
    },
    async queryInnerMessageTabs({ rootState }, params = {}) {
      const data = await rootState.http("/message/aggregate/inner/queryInnerMessageTabs", params);
      return data;
    },
    async getCustomerHelperHome({ rootState }, params = {}) {
      const data = await rootState.http("/getCustomerHelperHome", params);
      return data;
    }
  }
};

export default crossApp;



// WEBPACK FOOTER //
// ./src/store/modules/cross-app.js